<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-03-03 14:26:02
 * @LastEditTime: 2023-03-10 15:48:35
 * @Description: 
-->
<template>
    <div>
        <!-- Retirement Request List -->
        <div v-if="requestBool == 0">

            <!-- International Carbon Credit Quantity: -->
            <div class="top">
                <div class="top_h3">International Carbon Credit Balance:</div>
                <div class="top_h2">10,000</div>
            </div>

            <div class="title">Carbon Credit Transfer Request</div>

            <!-- 搜索 -->
            <div class="search">
                <el-row :gutter="20" type="flex" align="bottom">
                    <el-col :span="8">
                        <div class="search_t">User Name</div>
                        <el-input v-model="fromData.projectId" clearable placeholder="Project ID"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <div class="search_t">Status</div>
                        <el-select v-model="fromData.status" style="width:100%" clearable placeholder="All">
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8">
                        <div class="search_btn">Search</div>
                    </el-col>
                </el-row>
            </div>

            <!-- 新建 -->
            <div class="flex">
                <div class="flex_w" @click="changeRequestBool">
                    <img src="@/assets/img/h_logo.png" class="img" alt="">
                    <div class="f_t">New Transfer Request</div>
                </div>
            </div>

            <!-- 表格 -->
            <div>
                <el-table
                    :data="tableData.slice((currentPage - 1) * pageSize,currentPage * pageSize)"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 100%"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="userName" label="User Name"></el-table-column>
                    <el-table-column prop="status" label="Status">
                        <template  slot-scope="scope">
                            <div v-if="scope.row.status == 1">Pending</div>
                            <div v-if="scope.row.status == 2">Retired</div>
                            <div v-if="scope.row.status == 3">Rejected</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requestTime" width="140px" label="Request Time">
                        <template  slot-scope="scope">
                            <div>{{ formatDates(scope.row.requestTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accountNumber" label="Agency Account Number"></el-table-column>
                    <el-table-column prop="quantity" label="Transfer Quantity (Tonnes)"></el-table-column>
                    <el-table-column label="Action">
                        <template  slot-scope="scope">
                            <div class="view" @click="changerequestBool(scope.row)">View</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="display_flex" style="margin-top: 47px">
                    <el-pagination
                    v-if="tableData.length != 0"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    class="pagination"
                    prev-text="<"
                    next-text=">"
                    :total="tableData.length"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <div v-if="requestBool == 1">
            <!-- International Carbon Credit Quantity: -->
            <div class="top">
                <div class="top_h3">International Carbon Credit Balance:</div>
                <div class="top_h2">10,000</div>
            </div>

            <!-- Retirement Request -->
            <div class="d_t">Carbon Credit Transfer</div>

            <!-- 搜索 -->
            <div class="search">
                <el-row :gutter="20" type="flex" align="bottom">
                    <el-col :span="8">
                        <div class="search_t">Project ID</div>
                        <el-input v-model="fromData1.projectId" clearable placeholder="Project ID"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <div class="search_t">Status</div>
                        <el-select v-model="fromData1.status" style="width:100%" clearable placeholder="All">
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8">
                        <div class="search_btn">Search</div>
                    </el-col>
                </el-row>
            </div>

            <!-- 表格 -->
            <div class="mg_t_50">
                <el-table
                    :data="tableData1"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 100%"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="projectId" width="100px" label="Project ID">
                        <template  slot-scope="scope">
                            <div class="view" @click="gotoDetail(scope.row)">{{scope.row.projectId}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" width="230px" label="Project Name">
                        <template  slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.projectName" placement="bottom">
                                <div class="t_txt w_130">{{ scope.row.projectName }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="vintage" width="240px" label="Vintage"></el-table-column>
                    <el-table-column prop="quantity" label="Transfer Quantity / ICC Quantity">
                        <template  slot-scope="scope">
                            <div class="t_txt w_130">{{ scope.row.quantity }}/{{ scope.row.quantity1 }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Action" width="80px">
                        <template slot-scope="scope">
                            <el-popover width="300" placement="top" v-model="scope.row.visible">
                                <div class="banner">
                                    <div class="tlt">Enter Retire Quantity</div>
                                    <el-input v-model="scope.row.quantity" clearable placeholder="Region"></el-input>
                                    <div class="btn" @click="changevisible(scope.row)">Confirm</div>
                                </div>
                                <div class="action_btn" slot="reference">Apply</div>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tb_btm">Total Apply Quantity:{{ datanum }}</div>
            </div>

            <!-- Upload Document -->
            <div class="tb_2">
                <div class="h2">Document List</div>
                <div class="felx" @click="changeUploadDia">
                    <img src="@/assets/img/upload_logo.png" class="img" alt="">
                    <div class="h3">Upload Document</div>
                </div>
            </div>

            <!-- 表格 -->
            <div class="mg_t_50">
                <el-table
                    :data="tableData2"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 100%"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="documentType" label="Document Type"></el-table-column>
                    <el-table-column prop="documentName" label="Document Name"></el-table-column>
                    <el-table-column prop="documentDescription" label="Document Description"></el-table-column>
                    <el-table-column label="Action" width="80px">
                        <template slot-scope="scope">
                            <div class="action_btn_r" @click="DeleteDoc(scope)">Delete</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="btm_btn">
                <div class="flex">
                    <div class="can_btn" @click="cancelRequestBool">Cancel</div>
                    <div class="con_btn" @click="confirmRequestBool">Confirm</div>
                </div>
            </div>

            <div class="btm_dia_up">
                <el-dialog title="" :close-on-click-modal="false" :visible.sync="upload_dia" width="800px" center>
                    <div class="dia_banner">
                        <!-- <img src="@/assets/img/diaerr.png" class="diaerrimg" alt=""> -->
                        <div class="tlt">Document Upload</div>
                        <div class="f_t">Document Name</div>
                        <el-input v-model="upload.documentName" clearable placeholder="Document Name"></el-input>
                        <div class="f_t mg_t_40">Document Type</div>
                        <el-input v-model="upload.documentType" clearable placeholder="Document Type"></el-input>
                        <div class="f_t mg_t_40">Document Description</div>
                        <el-input type="textarea" :autosize="{minRows: 5}" placeholder="" v-model="upload.description"></el-input>
                        <div class="mg_t_40 upload">
                            <el-upload
                                accept=".doc,.docx,.xls.xlsx,jpg,.jpeg,.png,.pdf"
                                action="/api/file/upload/1"
                                :before-remove="beforeRemove"
                                :before-upload="beforeUpload"
                                multiple
                                :limit="1"
                                :on-success="handleSuccess"
                                :file-list="fileList"
                            >
                                <div class="upload_box">
                                    <div>
                                        <img src="@/assets/img/upload_j.png" alt="">
                                    </div>
                                    <div>Document Upload</div>
                                </div>
                                <div slot="tip" class="el-upload__tip">File Extension Supported: .doc. docx. xls. xlsx. jpg .png . jpeg. pdf File Support size: 3MB</div>
                            </el-upload>
                        </div>

                        <div class="up_btn" @click="changeuploaddia">Confirm</div>
                    </div>
                </el-dialog>
            </div>
        </div>

        <div v-if="requestBool == 2">
            <!-- International Carbon Credit Quantity: -->
            <div class="top">
                <div class="top_h3">International Carbon Credit Balance:</div>
                <div class="top_h2">10,000</div>
            </div>

            <!-- Retirement Request -->
            <div class="d_t">Carbon Credit Transfer Review</div>


            <!-- 表格 -->
            <div class="mg_t_50">
                <el-table
                    :data="tableData3"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 100%"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="projectId" label="Project ID">
                        <template  slot-scope="scope">
                            <div class="view" @click="gotoDetail(scope.row)">{{scope.row.projectId}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" label="Project Name">
                        <template  slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.projectName" placement="bottom">
                                <div class="t_txt w_130">{{ scope.row.projectName }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="vintage" label="Vintage"></el-table-column>
                    <el-table-column prop="retireQuantity" label="Transfer Quantity"></el-table-column>
                </el-table>
                <div class="tb_btm">Total Apply Quantity:{{datanums}}</div>
            </div>

            <!-- Upload Document -->
            <div class="tb_2">
                <div class="h2">Document List</div>
            </div>

            <!-- 表格 -->
            <div class="mg_t_50">
                <el-table
                    :data="tableData4"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 100%"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="documentType" label="Document Type"></el-table-column>
                    <el-table-column prop="documentName" label="Document Name"></el-table-column>
                    <el-table-column prop="documentDescription" label="Document Description"></el-table-column>
                    <el-table-column label="Action" width="100px">
                        <template slot-scope="scope">
                                <div class="action_btn_rs" @click="Download()">Download</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="btm_btn">
                <div class="flex">
                    <div class="can_btn" @click="cancelRequestBool">Back</div>
                </div>
            </div>
        </div>

    </div>
</template>
  
<script>
import carbon from "@/api/carbon.js";
import carbonRegistry from "@/api/carbonRegistry.js";
import { formatDate } from '@/util/date.js'
export default {
    name: 'carboncredit',
    components: {
    },
    data(){
      return {
        fromData:{
            projectId:"",
            status:"",
            pageNumber:1,
            pageSize:50,
        },
        fromData1:{
            status:"",
            projectId:"",
        },
        projectSectorList:[],
        statusList:[
            {
                value: '1',
                label: 'Pending'
            },
            {
                value: '2',
                label: 'Retired'
            },
            {
                value: '3',
                label: 'Rejected'
            },
        ],
        tableData:[
            {
                userName:'Ellen',
                status:"Pending",
                requestTime:"2022/12/21 12:00:00",
                accountNumber:"0001",
                quantity:"30000",
            }
        ],
        tableData1:[
            {
                id:'1',
                projectId:'43456',
                projectName:"Luyi Biogas Recovery and Utilization Project",
                vintage:"2021/12-2022/12",
                quantity:"0",
                quantity1:'2000',
                visible:false,
            },
            {
                id:'2',
                projectId:'65849',
                projectName:"Qingfeng Biogas Recovery and Utilization Project",
                vintage:"2021/12-2022/12",
                quantity:"0",
                quantity1:'2000',
                visible:false,
            },
            {
                id:'3',
                projectId:'58469',
                projectName:"Recyling Used Cooking Oil into Biodiesel in Bali",
                vintage:"2021/12-2022/12",
                quantity:"0",
                quantity1:'2000',
                visible:false,
            },
            {
                id:'4',
                projectId:'74586',
                projectName:"Huaxian Caiying Biogas Recovery and Utilization Project",
                vintage:"2021/12-2022/12",
                quantity:"0",
                quantity1:'2000',
                visible:false,
            },
            {
                id:'5',
                projectId:'32519',
                projectName:"Macaúbas Landfill Gas Project",
                vintage:"2021/12-2022/12",
                quantity:"0",
                quantity1:'2000',
                visible:false,
            },
        ],
        tableData2:[],
        tableData3:[],
        tableData4:[],
        pageSize: 10,
        currentPage: 1,
        requestBool:0,
        datanum:0,
        upload_dia:false,
        login:{},
        upload:{
            documentName:'',
            documentType:'',
            description:''
        },
        fileList: [],
      }
    },
    created(){
        this.login = JSON.parse(sessionStorage.getItem('login'))
    },
    mounted(){
        this.getProjectType()
        this.getTransferList()
    },
    methods:{
        formatDates(val){
            return formatDate(val)
        },
        changevisible(row){
            if(row.quantity/1 > row.quantity1/1){
                row.quantity = row.quantity1
            }
            this.datanum = this.datanum+row.quantity/1
            return row.visible = false
        },
        columnStyle({ row, column, rowIndex, columnIndex}){
            if(columnIndex == 1){
                return "color:#366F67;word-break:break-word;";
            }
            return "word-break:break-word;";
        },
        //翻页
        handleCurrentChange(updateCurrentPage) {
            this.currentPage = updateCurrentPage;
        },
        getProjectType() {
            carbonRegistry.getProjectType((res) => {
                this.projectSectorList = res.list;
            },{country:this.login.country});
        },
        getTransferList(){
            carbon.getTransferList((res) => {
                if(res.code == 200){
                    this.tableData = res.data.records
                }
            },this.fromData);
        },
        DeleteDoc(s){
            return this.tableData2.splice(s.$index,1)
        },
        changeuploaddia(){
            let obj = {
                documentName:this.upload.documentName,
                documentType:this.upload.documentType,
                description:this.upload.description,
            }
            this.upload_dia = false
            return this.tableData2.push(obj)
        },
        changerequestBool(row){
            
            carbon.getTransferdetail(res => {
                if(res.code == 200){
                    this.datanums = res.data.totalQuantity
                    this.tableData3 = res.data.transferList
                    this.tableData4 = res.data.documentList
                    this.requestBool = 2
                }
            },{id:row.id})
        },
        changeRequestBool(){
            this.requestBool = 1
        },
        change2(){
            this.requestBool = 2
        },
        cancelRequestBool(){
            this.requestBool = 0
        },
        Download(){
            window.location.href='/api/file/download'
        },
        confirmRequestBool(){
            let params = {
                totalQuantity:this.datanum,
                transferList:this.tableData1,
                documentList:this.tableData2
            }
            carbon.getTransferconfirm(res => {
                if(res.code == 200){
                    this.requestBool = 0
                    this.getTransferList()
                }
            },params)
        },
        changeUploadDia(){
            this.upload.documentName = ''
            this.upload.documentType = ''
            this.upload.description = ''
            this.upload_dia = true
        },

        // 上传
        beforeRemove(file) {},
        // 上传成功
        handleSuccess(file) {
            console.log('上传成功',file)
        },
        gotoDetail(row){
          this.$router.push({ path: "/carbonDetail2", query: { id: row.projectId } });
        },
        beforeUpload(file) {           
            console.log(file)           
            // var testmsg=file.name.substring(file.name.lastIndexOf('.')+1) 
            // console.log(testmsg)                       
            // const extension = testmsg === 'jpg'            
            // const extension2 = testmsg === 'png'
            // const extension3 = testmsg === 'gif'
            // const extension4 = testmsg === 'svg'  
            // const extension5 = testmsg === 'jpeg'            
            const isLt2M = file.size / 1024 / 1024 < 3          
            // if(!extension && !extension2 && !extension3 && !extension4 && !extension5) {                
            //     this.$message({                    
            //         message: '上传文件只能是 jpg、jpeg、png、gif、svg格式!',                    
            //         type: 'warning'               
            //     });            
            // } 
            if(!isLt2M) {           
                this.$message({           
                    message: 'File Support size: 3MB',            
                    type: 'warning'            
                });           
            }    
            return isLt2M                  
            // return (extension || extension2 || extension3 || extension4 || extension5) && isLt2M      
        },
    },
}
</script>
  
<style lang="scss" scoped>
.view_txt{
    font-size: 16px;
    font-family: ArialMT;
    color: #158869;
    line-height: 68px;
    cursor: pointer;
}
.mg_t_40{
    margin-top:40px;
}
.title{
    font-size: 30px;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
    margin-top: 50px;
}
.search{
    margin-top:50px;
    .search_t{
        font-size: 14px;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:10px;
    }
    .search_btn{
        width: 130px;
        height: 38px;
        border-radius: 8px;
        border: 1px solid #158869;
        font-size: 16px;
        color: #158869;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
.img{
    width: 15px;
    height: 16px;
}
.flex{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin:50px 0 15px 0; 
}
.display_flex{
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.flex_w{
    display: flex;
    align-items: center;
    .f_t{
        font-size: 14px;
        color: #158869;
        line-height: 16px;
        cursor: pointer;
        margin-left: 8px;
    }
}
.data-pic {
    width: 244px;
    height: 210px;
}
.nodata {
    font-size: 16px;
    font-family: ArialMT;
    color: #626262;
}
.t_txt{
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.w_130{
    max-width: 130px;
}
.w_100{
    max-width: 100px;
}
.w_120{
    max-width: 120px;
}


.top{
    width: calc(100% - 60px);
    height: 80px;
    background: #e1eeeb;
    border-radius: 8px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top_h3{
        font-size: 16px;
        color: #626262;
        line-height: 18px;
    }
    .top_h2{
        font-size: 30px;
        font-weight: 600;
        color: #000000;
        line-height: 34px;
    }
}
.d_t{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
    margin-top:50px;
}
.wd_90{
    width: 90px !important;
}
.mg_t_50{
    margin-top: 50px;
}
.action_btn{
    font-size: 16px;
    font-family: ArialMT;
    color: #158869;
    cursor: pointer;
}
.action_btn_r{
    font-size: 16px;
    font-family: ArialMT;
    color: #ED6666;
    cursor: pointer;
}
.action_btn_rs{
    font-size: 16px;
    font-family: ArialMT;
    color: #158869;
    cursor: pointer;
}
.banner{
    padding:20px;
    .tlt{
        text-align: center;
        font-size: 20px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #21212B;
        line-height: 28px;
        margin-bottom:30px;
    }
    .t2t{
        font-size: 14px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:12px;
    }
    .btn{
        margin: 30px auto auto auto;
        width: 125px;
        height: 44px;
        background: #158869;
        border-radius: 4px;
        display:flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-family: ArialMT;
        color: #FFFFFF;
        line-height: 18px;
    }
}
.tb_btm{
    width: calc(100% - 40px);
    height: 50px;
    background: #FFFFFF;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding:0 20px;
    font-size: 20px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 23px;
}
.tb_2{
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .h2{
        font-size: 30px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #1E1E1E;
        line-height: 34px;
    }
    .felx{
        display: flex;
        align-items: center;
        cursor: pointer;
        .img{
            width:20px;
            height:20px;
        }
        .h3{
            font-size: 14px;
            font-family: ArialMT;
            color: #158869;
            line-height: 16px;
            margin-left: 8px;
        }
    }
}
.btm_btn{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top:50px;
    .flex{
        display: flex;
        align-items: center;
        .can_btn{
            width: 110px;
            height: 38px;
            border-radius: 8px;
            border: 1px solid #158869;
            font-size: 16px;
            font-family: ArialMT;
            color: #158869;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
        .con_btn{
            width: 110px;
            height: 40px;
            background: #158869;
            border-radius: 8px;
            font-size: 16px;
            font-family: ArialMT;
            color: #FFFFFF;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 20px;
            cursor: pointer;
        }
    }
}
.dia_banner{
    width: 750px;
    .diaerrimg{
        width:52px;
        height:52px;
        margin: 0 auto;
        display: flex;
    }
    .tlt{
        font-size: 24px;
        font-family: Arial-BoldMT, Arial;
        font-weight: bold;
        color: #21212B;
        line-height: 28px;
        text-align: center;
        margin-top: 20px;
        margin-bottom:50px;
    }
    .f_t{
        font-size: 14px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:12px;
    }
    .mg_t_40{
        margin-top:40px;
    }
}
.upload_box{
    width:748px;
    height:222px;
    border:1px dashed #CCD2DA;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
        width:48px;
        height: 48px;
    }
}
.up_btn{
    margin: 50px auto;
    width: 125px;
    height: 44px;
    background: #158869;
    border-radius: 4px;
    font-size: 16px;
    font-family: ArialMT;
    color: #FFFFFF;
    line-height: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep .btm_dia_up{
    .el-dialog{
        margin-top: 15vh !important;
    }
}
.view{
    color:#013C89;
    cursor: pointer;
}
::v-deep .upload{
    .el-icon-close:before{
        content: "\e6db" !important;
    }
}
</style>
  